<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text dropdown">
                        <h1>
                            <b class="OpenSansFonts" style="font-weight: 600;">Microsoft Word</b>へ
                            <br />インストールして、
                            <br />
                            <b class="OpenSansFonts" style="font-weight: 600;">Trinka</b>をより身近に
                            <span>プレミアムプラン限定</span>
                        </h1>
                        <p>
                            <b class="OpenSansFonts" style="font-weight: normal;">Microsoft Word</b>用の
                            <b class="OpenSansFonts" style="font-weight: normal;">Trinka</b>アドインで、効果的な英語ライティングもらくらく！
                            <b class="OpenSansFonts" style="font-weight: normal;">Trinka</b>が
                            <b class="OpenSansFonts" style="font-weight: normal;">Word</b>での作業中に、ライティングを自動的にチェックします。</p>
                        <div id="MacMSWordButton">
                            <button title="MacOS用のWordアドインが間もなく登場">
                                <img src="../../../assets/images/safari_logo.png" alt="safari"> 近日公開
                            </button>
                            <span>
                                <a href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank">*ここからWindows用のアドインをダウンロードします。</a>
                            </span>
                        </div>
                        <div class="wordPluginCTA" id="MSWindowDownloadButton">
                            <b id="windowSystemDetect"></b>
                            <i class="betaTagText OpenSansFonts">Beta</i>
                        </div>
                        <!-- <a> <img src="../../../assets/images/whitePaper_download.png" alt=""> ダウンロード中</a> -->
                        <span>*Word 2010以降 / Windows のバージョンで動作します。</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/MSWordBanner.png" alt="ms word プラグイン - 文法 チェック">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>使い方は とっても
                                <br />シンプル</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="" style="width: 50px; height: 50px;">
                                </div>
                                <h3>ダウンロード</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>インストール</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>校正スタート！</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="accomplishSections_img">

                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../assets/images/microsoft-wordThumbnails.jpg" alt="ms word - 英文校正" class="img-fluid eposter-img">
                            <!-- <img src="https://i.ytimg.com/vi/uNNpxOtvJ80/maxresdefault.jpg" alt=""> -->
                        </a>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="spellcheck_heading EnhancementsHeadingSection">
                        <h2>
                            Windows版Word用のTrinka
                            <br>アドインをご利用ください
                        </h2>
                        <div class="HeadingSubLine"></div>
                        <p>アドインのインストールや設定の方法についてお困りですか？
                        </p>
                        <p>TrinkaをWordの拡張機能としてご利用いただく方法を説明したこちらのチュートリアル動画をご覧いただけば、簡単にお使いいただけます。
                        </p>
                        <p>ご不明点については、
                            <a (click)="scroll(target)" class="text-link">FAQ</a>もご覧ください。
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>使い方はとってもシンプル</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinkaは、お使い慣れたMS Wordへのアドインとしてもご利用可能です。文章を書くその場でTrinkaがライティングを自動的にチェックするから、エラーフリーの英文を簡単に作成いただけます。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="スタイルガイドに合わせた校正 - 英文チ ェッカー">
                        <h3>スタイルガイドに合わせた校正</h3>
                        <p>スタイルガイドに合わせた文法、表記ルール、語彙等の校正を行います（AMA 11thまたはAGU 2017）。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="専門分野と文書タイプに 最適な校正 - ai英文校正">
                        <h3>専門分野と文書タイプに 最適な校正</h3>
                        <p>専門分野や、原著論文、ケースレポートなど原稿の種類を指定することで、ファイルに最適な修正案を提示できます。</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <span>Only with Premium</span>
                        <img src="../../../assets/images/powerMode_icon.svg" alt="" style="max-width: 28px;">
                        <h3>パワーモード
                            <b>(Coming Soon)</b>
                        </h3>
                        <p>最先端のAIにより、通常モードより最大40%多くの文法や文脈に基づく改善案を提示。プレミアムプランのファイル自動校正でご利用可能。近日中にTrinka Cloud、Wordアドイン、ブラウザアドインでもご利用いただけます。</p>
                    </div>
                </div> -->

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="辞書への追加 - 英文 チェック">
                        <h3>辞書への追加</h3>
                        <p>マイ・ディクショナリーに用語を追加すれば、Trinkaがそれをスペルミスと判断することはなくなります。マイ・ディクショナリーはProfile欄から確認・編集もできます。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt=">安心のデータセキュリティ - 英文校正 ai">
                        <h3>安心のデータセキュリティ</h3>
                        <p>入力した文章はリアルタイムで分析され、Trinkaのサーバーに保存されることはありません。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/sendForHumanEditing.svg" alt="専門家への校正依頼もシンプル - 英文校正">
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>専門家への校正依頼もシンプル</h3>
                        <p>専門家による最終校正をご依頼されたい場合は、Trinkaからファイルを直接エナゴにお送りいただけます。ご依頼フォームの自動見積り機能で事前に金額を確認できるから、安心です。</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>よくあるご質問</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Microsoft WordへTrinkaのアドインをインストールする方法は？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>TrinkaのMicrosoft Word 用アドインページの「ダウンロードする」をクリックしてください。ダウンロードしたファイルをクリックするとインストールが始まります。</p>
                                        <p>インストール完了後、Microsoft Wordを開くと、画面上部に「Trinka」という新しいタブが表示されます。このタブをクリックし、「Log In」ボタンからプレミアムアカウントでログインすると、WordでTrinkaをお使いいただけます。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Microsoft WordでTrinkaの文法チェックを有効にする方法は？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Microsoft Word用のTrinkaアドインをダウンロードしてインストールした状態であれば、Trinkaのアカウントの認証を行ってログインし、Wordの画面上部の「Trinka」タブにある「Start」ボタンをクリックするだけでTrinkaが動作します。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Microsoft WordにTrinkaをインストールするためのシステム要件は何ですか？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Word用アドインは、Windows版Microsoft Word 2010以降のバージョンで動作します。
                                        </p>
                                        <p>Windows版のWord用アドインをインストールするには、8GB以上の空き容量が必要です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Mac版のMicrosoft Word用のプラグインは現在開発中で、近日公開予定です。 
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Mac版MS Word用Trinkaアドイン（ベータ版）は<a href="https://appsource.microsoft.com/en-us/product/office/WA200004694?tab=Overview" target="_blank" class="text-link">こちらのページ</a>からお試しください。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Microsoft Wordにアドインをインストールすれば、スペルや文法をリアルタイムにチェックしてくれますか？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。アドインをインストールすることで、Wordに入力した英文がリアルタイムでチェックされ、修正案が提示されます。さらに、変更を加えると、変更箇所の再チェックが即時に行われます。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        修正・変更の提案を承認したり却下したりする方法は？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>修正・変更案の承認や却下は非常に簡単です。提案された単語をクリックすると承認、親指が下に向いたアイコンをクリックすると却下できます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        アメリカ英語でのチェックとイギリス英語でのチェックの切り替えはできますか？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。「Trinka」タブ内の「Language check and settings」グループからアメリカ英語とイギリス英語の切り替えが可能です。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        Trinka のWordアドインでも、スタイルガイドを選んでそれに準拠したチェックができますか？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。「Trinka」タブ内の「Language check and settings」グループからご希望のスタイルガイドを選択いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        Microsoft Wordを持っておらず、オンラインのGoogleドキュメントやMediumを使って執筆している場合は、Trinkaは使えますか？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Chrome、Firefox、Edge用の
                                            <a [routerLink]="['/browser-plugin']" class="text-link" target="_blank">Trinkaブラウザアドイン</a>をダウンロードいただけば、お好きなサイトでTrinkaをご利用いただけます。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        インストールしたはずのアドインが見つかりません。
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>システムや組織のセキュリティ設定によりアドインが無効になっている場合があります。その場合は、「ファイル」→「オプション」→「アドイン」→「管理」→「COM アドイン」から、手動でアドインを有効にすることができます。詳細は
                                            <a href="https://youtu.be/RDrzQOBNAsk" target="_blank" class="text-link">こちらの動画</a>をご覧ください。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        Trinkaのアドインでミスが検出されません。
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>複数の原因が考えられます。</p>
                                        <ul>
                                            <li>インターネットに接続されているか確認してください。Trinkaがエラーを検出して修正を提案するには、インターネット接続が必要です。</li>
                                            <li>システム／組織のセキュリティ設定でアドインが無効になっていないか確認してください。
                                            </li>
                                            <li>アドインをアンインストールして、再度インストールしてみてください。</li>
                                            <li>それでも問題が解決しない場合は、
                                                <a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a> までメールでご連絡ください。サポートスタッフが解決のお手伝いをいたします。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    
    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word - 文法 チェック">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li> -->
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/other_Apps_browser.svg" alt="browser - 文法 チェック">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise - 文法 チェック">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>